<div class="dataview">
  <div class="summary-container">
    <div class="data-results-summary">
      <span class="results-count">{{totalCount}} {{totalCount === 1 ? 'item' : 'items'}}</span>
    </div>
  </div>
  <div class="dataview-tools">
    <ng-content select="[topToolbar]"></ng-content>
    <div class="toolContainer">
      <mat-slide-toggle *ngIf="showSelectedOnlyToggle"
                        class="datex-toggle centered-content margin-left-0"
                        [checked]="showOnlySelected"
                        (change)="onShowOnlyToggleChange($event)">Show selected only</mat-slide-toggle>
    </div>
    <div *ngIf="showFilter"
         class="query-filter">
      <input matInput
             autocomplete="off"
             class="datex-textbox query-search"
             spellcheck="false"
             placeholder="Filter"
             [(ngModel)]="fullTextSearch" />
    </div>
  </div>
  <div class="dataview-filters">
    <ng-content select="[filters]"></ng-content>
  </div>

  <div class="dataview-grid styled-grid"
       style="height: 100%">
    <div class="grid-container"
         data-cy="grid"
         style="height: 100%; min-height: 100px;">
      <ag-grid-angular #agGrid
                       class="ag-theme-quartz"
                       style="height: 100%;"
                       [columnDefs]="agColDefs"
                       [rowSelection]="agSelection"
                       [rowData]="rows"
                       [rowHeight]="rowHeight"
                       [suppressCellFocus]="suppressCellFocus"
                       [suppressDragLeaveHidesColumns]="true"
                       [suppressContextMenu]="true"
                       [isExternalFilterPresent]="isExternalFilterPresent.bind(this)"
                       [doesExternalFilterPass]="doesExternalFilterPass"
                       (gridReady)="onAgGridReady($event)"
                       [defaultColDef]="defaultColDef"
                       [rowClassRules]="rowClassRules"
                       (selectionChanged)="onSelectionChanged($event)"
                       [getRowId]="getRowId" />
    </div>
  </div>

</div>